import { render, staticRenderFns } from "./contentUserGroupDelete.vue?vue&type=template&id=6be3764e&"
import script from "./contentUserGroupDelete.vue?vue&type=script&lang=js&"
export * from "./contentUserGroupDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports